import { Coins } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { useAuthenticatedQuery } from '../hooks/useAuthenticatedQuery';
import { trpc } from '../lib/trpc';

// Saldo de créditos siempre visible (regla de transparencia de la propuesta de monetización).
// Enlaza a la página "Mi Plan".
export function CreditsBadge() {
  const { t } = useTranslation();
  const { enabled } = useAuthenticatedQuery();
  const { data } = trpc.billing.me.useQuery(undefined, { enabled });

  if (!data) return null;

  return (
    <Link
      to="/plan"
      title={t('Plan {{plan}} · {{credits}} créditos disponibles', {
        plan: data.plan?.name ?? 'Free',
        credits: data.credits,
      })}
      className="flex h-10 items-center gap-1.5 rounded-xl border border-warning/25 bg-warning/10 px-2.5 text-sm font-semibold text-warning transition hover:bg-warning/15 sm:px-3"
    >
      <Coins className="h-4 w-4" />
      <span>{data.credits}</span>
      <span className="hidden text-xs font-normal opacity-80 xl:inline">
        {t('créditos')}
      </span>
    </Link>
  );
}
